






















































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PingPongPage extends Vue {
  private status: number = this.$enum.finance.RechargeResultStatus.ORIGINAL;
  private created(): void {
    const serialNumber = this.$route.query.serial_number;
    const orderNumber = this.$route.query.order_number;
    window.opener && window.opener.MESSENGER.emit('pingpongRechargeResult', {
      code: serialNumber,
      orderNumber,
    }, (status: number) => {
      this.status = status;
      if ([this.$enum.finance.RechargeResultStatus.SUCCESS, this.$enum.finance.RechargeResultStatus.ERROR].indexOf(this.status) > -1) {
        window.close();
      }
    });
  }
}
